import { useEffect, useRef, Dispatch } from 'react';
import { AppState, MainContextActionTypes } from '@constants';
import { validateCouponOnCartChange } from '@utils/validateCouponOnCartChange';

/**
 * Hook that validates applied coupons whenever cart items change
 */
export function useCouponValidation(state: AppState, dispatch: Dispatch<MainContextActionTypes>) {
  const previousCartItemsRef = useRef(state.cartItems);

  useEffect(() => {
    // Only validate if cart items actually changed and we have a coupon applied
    const cartItemsChanged = JSON.stringify(previousCartItemsRef.current) !== JSON.stringify(state.cartItems);

    if (cartItemsChanged && state.couponCode) {
      validateCouponOnCartChange(state, dispatch);
    }

    // Update the ref for next comparison
    previousCartItemsRef.current = state.cartItems;
  }, [state.cartItems, state.couponCode, state.price, dispatch]);
}
